var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": 60,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "div",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _c("span", [_vm._v(_vm._s(_vm.modalTitle))]),
              ]
            ),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c("orm-vehicle-location-reason", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.componentStatuses[0],
                    expression: "componentStatuses[0]",
                  },
                ],
                model: {
                  value: _vm.sendQuoteObject,
                  callback: function ($$v) {
                    _vm.sendQuoteObject = $$v
                  },
                  expression: "sendQuoteObject",
                },
              }),
              _vm.value && _vm.sendQuoteType === _vm.ormSendQuoteTypes.Quote
                ? _c("orm-item-comments", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.componentStatuses[1],
                        expression: "componentStatuses[1]",
                      },
                    ],
                    attrs: { quote: _vm.value },
                    model: {
                      value: _vm.sendQuoteObject,
                      callback: function ($$v) {
                        _vm.sendQuoteObject = $$v
                      },
                      expression: "sendQuoteObject",
                    },
                  })
                : _vm._e(),
              _vm.value
                ? _c("image-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.componentStatuses[
                            _vm.components.length === 3 ? 2 : 1
                          ],
                        expression:
                          "componentStatuses[components.length === 3 ? 2 : 1]",
                      },
                    ],
                    attrs: {
                      "quote-id": _vm.value.quoteId,
                      "pre-select": "NotSent",
                    },
                    model: {
                      value: _vm.selectedImageIds,
                      callback: function ($$v) {
                        _vm.selectedImageIds = $$v
                      },
                      expression: "selectedImageIds",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeComponent > 0,
                      expression: "activeComponent > 0",
                    },
                  ],
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Previous" },
                  on: {
                    click: function ($event) {
                      return _vm.previous()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-24px mdi-chevron-left" }),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeComponent < _vm.components.length - 1,
                      expression: "activeComponent < components.length - 1",
                    },
                  ],
                  staticClass: "button is-success tooltip",
                  attrs: {
                    "data-tooltip": "Next",
                    disabled: _vm.isNextDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.next()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-24px mdi-chevron-right" }),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeComponent === _vm.components.length - 1,
                      expression: "activeComponent === components.length - 1",
                    },
                  ],
                  staticClass: "button is-success tooltip",
                  attrs: {
                    "data-tooltip": "Submit",
                    disabled: _vm.isSubmitDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-small" }, [
                    _c("i", { staticClass: "mdi mdi-18px mdi-send" }),
                  ]),
                  _c("span", [_vm._v("Submit")]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button tooltip",
                  attrs: {
                    "data-tooltip": "Cancel",
                    disabled: _vm.cancelDisabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("span", [_vm._v("Cancel")])]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }